var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _rect, _rect2, _path124, _path125, _path126, _path127, _path128;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlide1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 628,
    viewBox: "0 0 1200 628",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1200 0H0V628H1200V0Z",
    fill: "#A6EEFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1087 548.6C1087 577.8 1078.6 605 1064.2 628H146.4C125.2 592.4 113 550.7 113 506.2C113 391.8 193.6 296.3 301.1 273.2C300.9 270.6 300.8 268 300.8 265.4C300.8 212.9 343.3 170.4 395.8 170.4C415.5 170.4 433.8 176.4 448.9 186.6C507.6 121.2 592.8 80.1001 687.7 80.1001C864.9 80.1001 1008.6 223.8 1008.6 401C1008.6 406.4 1008.5 411.7 1008.2 417C1055.1 442.2 1087 491.7 1087 548.6Z",
    fill: "#44B4B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M880.7 231.9C865.2 231.9 852.2 242.3 848.2 256.4H913.3C909.2 242.2 896.1 231.9 880.7 231.9Z",
    fill: "#CFF8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M969.5 231.9C954 231.9 941 242.3 937 256.4H1002.1C998 242.2 984.9 231.9 969.5 231.9Z",
    fill: "#CFF8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M927.2 221.4C905.1 221.4 886.5 236.2 880.7 256.5H973.7C967.9 236.2 949.3 221.4 927.2 221.4Z",
    fill: "#CFF8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M607.9 123.8C597.7 123.8 589 130.7 586.3 140.1H629.4C626.8 130.7 618.1 123.8 607.9 123.8Z",
    fill: "#7DE3F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M666.7 123.8C656.5 123.8 647.8 130.7 645.1 140.1H688.2C685.6 130.7 677 123.8 666.7 123.8Z",
    fill: "#7DE3F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M638.7 116.8C624.1 116.8 611.7 126.6 607.9 140H669.5C665.7 126.6 653.3 116.8 638.7 116.8Z",
    fill: "#7DE3F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M221.3 114.1C185.5 114.1 155.4 138.1 146 170.9H296.6C287.2 138.1 257.1 114.1 221.3 114.1Z",
    fill: "#CFF8FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M426.7 114.1C390.9 114.1 360.8 138.1 351.4 170.9H502C492.6 138.1 462.5 114.1 426.7 114.1Z",
    fill: "#CFF8FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M328.8 89.8C277.7 89.8 234.6 124.1 221.3 170.9H436.4C423 124 379.9 89.8 328.8 89.8Z",
    fill: "#CFF8FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M208 161.2C185.7 161.2 167 176.1 161.1 196.5H254.8C249 176.1 230.3 161.2 208 161.2Z",
    fill: "#7DE3F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M335.8 161.2C313.5 161.2 294.8 176.1 288.9 196.5H382.7C376.9 176.1 358.1 161.2 335.8 161.2Z",
    fill: "#7DE3F4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M274.9 146.1C243.1 146.1 216.3 167.4 208 196.6H341.8C333.5 167.4 306.7 146.1 274.9 146.1Z",
    fill: "#7DE3F4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M591.9 434.7C534.9 434.7 486.9 472.9 472 525.1H711.9C696.9 472.9 648.8 434.7 591.9 434.7Z",
    fill: "#0181A1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M919 434.7C862 434.7 814 472.9 799.1 525.1H1039C1024.1 472.9 976 434.7 919 434.7Z",
    fill: "#2F7D80"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M763.2 396C681.8 396 613.2 450.6 591.9 525.1H934.5C913.2 450.6 844.6 396 763.2 396Z",
    fill: "#0181A1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M776.3 253.2C756.7 253.2 740.2 266.3 735 284.3H817.5C812.4 266.3 795.9 253.2 776.3 253.2Z",
    fill: "#7DE3F4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M888.9 253.2C869.3 253.2 852.8 266.3 847.6 284.3H930.1C925 266.3 908.5 253.2 888.9 253.2Z",
    fill: "#7DE3F4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M835.2 239.8C807.2 239.8 783.6 258.6 776.3 284.2H894.2C886.8 258.6 863.2 239.8 835.2 239.8Z",
    fill: "#7DE3F4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M200.129 462.505C175.343 462.505 154.492 479.239 148 502.013H252.159C245.766 479.239 224.915 462.505 200.129 462.505Z",
    fill: "#2F7D80"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M342.253 462.505C317.467 462.505 296.615 479.239 290.124 502.013H394.382C387.89 479.239 367.039 462.505 342.253 462.505Z",
    fill: "#006184"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M274.584 445.574C239.274 445.574 209.373 469.437 200.128 502.014H348.941C339.696 469.437 309.894 445.574 274.584 445.574Z",
    fill: "#006184"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M941.7 396.6C941.7 401.1 941.7 405.6 941.6 410.1C941.6 412.1 941.5 414.2 941.5 416.2C941.5 418.8 941.4 421.3 941.3 423.9C941.3 425.7 941.2 427.4 941.2 429.2C940.6 446 939.6 462.4 938.3 478.2C938 482.1 937.6 485.9 937.2 489.7C937.1 491 936.9 492.3 936.8 493.6C935.5 505.9 934 517.9 932.2 529.4H763.5C763.4 528.7 763.3 527.9 763.2 527.2C761.1 513.4 759.4 499.1 758 484.2C757.9 483.4 757.8 482.6 757.8 481.7C757.5 478.6 757.2 475.4 757 472.2C755.8 457.9 755 443.2 754.5 428.1C754.5 427.3 754.5 426.4 754.4 425.6C754.3 421.3 754.2 416.9 754.1 412.6C754 407.3 754 401.9 754 396.5C754 386.3 754.2 376.1 754.5 365.9C754.5 364.6 754.6 363.2 754.6 361.9C754.7 359 754.8 356 754.9 353.1C755 351.3 755.1 349.5 755.1 347.7C755.9 329.9 757.2 312.2 758.9 294.9C759 293.9 759.1 293 759.2 292C759.7 286.7 760.3 281.4 760.9 276.2C761.8 268.2 762.8 260.4 763.9 252.7C765.8 239.1 768 225.9 770.4 213.1C771.3 208.4 772.2 203.8 773.1 199.2C773.4 197.6 773.7 196.1 774.1 194.6C774.5 192.7 774.9 190.7 775.4 188.8C778.9 173 782.8 158.3 786.9 144.7C790.6 132.7 794.5 121.6 798.7 111.7C798.7 111.6 798.8 111.5 798.8 111.4H896.6C900.2 120 903.7 129.5 906.9 139.7C907.9 142.8 908.9 145.9 909.8 149.1C913.2 160.7 916.4 173 919.4 186.1C920.2 189.5 920.9 192.9 921.7 196.4C922.3 199.4 923 202.5 923.6 205.6C924.8 211.5 925.9 217.5 927 223.6C927.7 227.8 928.5 232 929.1 236.4C929.7 240.1 930.3 243.8 930.8 247.5C932.9 261.4 934.6 275.7 936.1 290.3C936.5 294 936.8 297.6 937.2 301.3C937.2 301.6 937.2 301.9 937.3 302.1C938.7 317.2 939.7 332.5 940.5 347.9C940.6 350.4 940.7 352.8 940.8 355.3C940.9 357.1 940.9 358.8 941 360.6C941.5 372.7 941.7 384.7 941.7 396.6Z",
    fill: "#006184"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M941.5 416.3C941.4 420.6 941.3 425 941.2 429.3L773.2 199.3C773.9 195.8 774.7 192.3 775.4 188.9L941.5 416.3Z",
    fill: "#01B6D1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M927.1 223.8L845.1 111.5L818.8 75.4C820.5 73.1 822.3 71.1 824.1 69.2L855 111.5L923.8 205.7C924.9 211.7 926 217.7 927.1 223.8Z",
    fill: "#01B6D1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M844.8 111.5L770.5 213.2C771.4 208.5 772.3 203.9 773.2 199.3C773.5 197.7 773.8 196.2 774.2 194.7L835 111.5H844.8Z",
    fill: "#01B6D1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M891.2 111.5L759.3 292.1C759.8 286.8 760.4 281.5 761 276.3L881.4 111.5H891.2Z",
    fill: "#01B6D1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M910 149.2L754.6 362C754.7 359.1 754.8 356.1 754.9 353.2C755 351.4 755.1 349.6 755.1 347.8L907 139.8C908.1 142.9 909 146 910 149.2Z",
    fill: "#01B6D1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M921.8 196.5L754.4 425.8C754.3 421.5 754.2 417.1 754.1 412.8L919.6 186.2C920.4 189.6 921.1 193.1 921.8 196.5Z",
    fill: "#01B6D1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M930.9 247.6L758 484.4C757.9 483.6 757.8 482.8 757.8 481.9C757.5 478.8 757.2 475.6 757 472.4L929.2 236.6C929.8 240.2 930.4 243.9 930.9 247.6Z",
    fill: "#01B6D1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M937.4 302.3L771.4 529.5H763.5C763.4 528.8 763.3 528 763.2 527.3L936.2 290.4C936.6 294.1 936.9 297.7 937.3 301.4C937.3 301.8 937.3 302 937.4 302.3Z",
    fill: "#01B6D1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M941 360.8L817.8 529.5H808L940.5 348C940.6 350.5 940.7 352.9 940.8 355.4C940.9 357.2 941 359 941 360.8Z",
    fill: "#01B6D1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M941.6 410.1C941.6 412.1 941.5 414.2 941.5 416.2C941.5 418.8 941.4 421.3 941.3 423.9L864.2 529.5H854.4L941.6 410.1Z",
    fill: "#01B6D1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M938.2 478.3C937.9 482.2 937.5 486 937.1 489.8C937 491.1 936.8 492.4 936.7 493.7L910.5 529.5H900.7L938.2 478.3Z",
    fill: "#01B6D1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M883.7 529.5H873.9L754.4 366.1C754.5 361.8 754.7 357.6 754.9 353.3L883.7 529.5Z",
    fill: "#01B6D1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M940.8 355.5L787 144.8C790.7 132.8 794.6 121.7 798.8 111.8L937.3 301.4C938.9 319.2 940.1 337.3 940.8 355.5Z",
    fill: "#003057"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M937.1 489.8C935.7 503.5 934 516.8 932.1 529.6H930.3L759 295C760.4 280.6 762.1 266.5 764 252.8L937.1 489.8Z",
    fill: "#003057"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M828.5 529.5H792.6L757.8 481.9C756.2 464.6 755.1 446.7 754.5 428.3L828.5 529.5Z",
    fill: "#003057"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M896.7 111.5H798.9C805.1 96.8 811.7 84.6 818.7 75.4C820.4 73.1 822.2 71.1 824 69.2C831.6 61.2 839.6 56.8 847.8 56.8C865.7 56.8 882.5 77.5 896.7 111.5Z",
    fill: "#003057"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M589.7 203.9H506.7V531H589.7V203.9Z",
    fill: "#E83857"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M570.7 130.9H525.7V405H570.7V130.9Z",
    fill: "#E83857"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M598.3 211.5H498L525.7 154.8H570.7L598.3 211.5Z",
    fill: "#FC4E6D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M573.2 132.7H523.1L543.1 104.4H553.2L573.2 132.7Z",
    fill: "#FC4E6D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M553.3 87.2H543.1V113.2H553.3V87.2Z",
    fill: "#FC4E6D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M550.9 71H545.5V97H550.9V71Z",
    fill: "#FC4E6D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M549.2 55.7H547.2V81.7H549.2V55.7Z",
    fill: "#FC4E6D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M598.3 228.6H498V311.6H598.3V228.6Z",
    fill: "#FC4E6D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M598.3 336.3H498V529.9H598.3V336.3Z",
    fill: "#FC4E6D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M548.2 301.2C565.376 301.2 579.3 287.276 579.3 270.1C579.3 252.924 565.376 239 548.2 239C531.024 239 517.1 252.924 517.1 270.1C517.1 287.276 531.024 301.2 548.2 301.2Z",
    fill: "#E83857"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M565.702 286.469C574.768 276.8 574.28 261.612 564.61 252.545C554.941 243.479 539.752 243.968 530.686 253.637C521.62 263.307 522.109 278.495 531.778 287.561C541.448 296.628 556.636 296.139 565.702 286.469Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M548.2 250.9V255",
    stroke: "#E83857",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M548.2 286.4V290.4",
    stroke: "#E83857",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M567.9 270.7H563.8",
    stroke: "#E83857",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M532.5 270.7H528.4",
    stroke: "#E83857",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M546.4 270.1C546.4 269.1 547.2 268.4 548.1 268.4C549 268.4 549.8 269.2 549.8 270.1C549.8 271 549 271.8 548.1 271.8C547.2 271.8 546.4 271 546.4 270.1Z",
    fill: "#E83857"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M538 279.5L548.2 270.1",
    stroke: "#E83857",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M538.3 254.2L548.2 270.1",
    stroke: "#E83857",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M510.4 401.2C508.7 401.2 507.3 399.8 507.3 398.1V351.2C507.3 349.5 508.7 348.1 510.4 348.1C512.1 348.1 513.5 349.5 513.5 351.2V398.1C513.6 399.8 512.2 401.2 510.4 401.2Z",
    fill: "#E83857"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M523 401.2C521.3 401.2 519.9 399.8 519.9 398.1V351.2C519.9 349.5 521.3 348.1 523 348.1C524.7 348.1 526.1 349.5 526.1 351.2V398.1C526.1 399.8 524.7 401.2 523 401.2Z",
    fill: "#E83857"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M535.6 401.2C533.9 401.2 532.5 399.8 532.5 398.1V351.2C532.5 349.5 533.9 348.1 535.6 348.1C537.3 348.1 538.7 349.5 538.7 351.2V398.1C538.7 399.8 537.3 401.2 535.6 401.2Z",
    fill: "#E83857"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M548.2 401.2C546.5 401.2 545.1 399.8 545.1 398.1V351.2C545.1 349.5 546.5 348.1 548.2 348.1C549.9 348.1 551.3 349.5 551.3 351.2V398.1C551.3 399.8 549.9 401.2 548.2 401.2Z",
    fill: "#E83857"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M560.7 401.2C559 401.2 557.6 399.8 557.6 398.1V351.2C557.6 349.5 559 348.1 560.7 348.1C562.4 348.1 563.8 349.5 563.8 351.2V398.1C563.9 399.8 562.5 401.2 560.7 401.2Z",
    fill: "#E83857"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M573.3 401.2C571.6 401.2 570.2 399.8 570.2 398.1V351.2C570.2 349.5 571.6 348.1 573.3 348.1C575 348.1 576.4 349.5 576.4 351.2V398.1C576.4 399.8 575 401.2 573.3 401.2Z",
    fill: "#E83857"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M585.9 401.2C584.2 401.2 582.8 399.8 582.8 398.1V351.2C582.8 349.5 584.2 348.1 585.9 348.1C587.6 348.1 589 349.5 589 351.2V398.1C589 399.8 587.6 401.2 585.9 401.2Z",
    fill: "#E83857"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M510.4 468C508.7 468 507.3 466.6 507.3 464.9V418C507.3 416.3 508.7 414.9 510.4 414.9C512.1 414.9 513.5 416.3 513.5 418V464.9C513.6 466.6 512.2 468 510.4 468Z",
    fill: "#E83857"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M523 468C521.3 468 519.9 466.6 519.9 464.9V418C519.9 416.3 521.3 414.9 523 414.9C524.7 414.9 526.1 416.3 526.1 418V464.9C526.1 466.6 524.7 468 523 468Z",
    fill: "#E83857"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M535.6 468C533.9 468 532.5 466.6 532.5 464.9V418C532.5 416.3 533.9 414.9 535.6 414.9C537.3 414.9 538.7 416.3 538.7 418V464.9C538.7 466.6 537.3 468 535.6 468Z",
    fill: "#E83857"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M548.2 468C546.5 468 545.1 466.6 545.1 464.9V418C545.1 416.3 546.5 414.9 548.2 414.9C549.9 414.9 551.3 416.3 551.3 418V464.9C551.3 466.6 549.9 468 548.2 468Z",
    fill: "#E83857"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M560.7 468C559 468 557.6 466.6 557.6 464.9V418C557.6 416.3 559 414.9 560.7 414.9C562.4 414.9 563.8 416.3 563.8 418V464.9C563.9 466.6 562.5 468 560.7 468Z",
    fill: "#E83857"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M573.3 468C571.6 468 570.2 466.6 570.2 464.9V418C570.2 416.3 571.6 414.9 573.3 414.9C575 414.9 576.4 416.3 576.4 418V464.9C576.4 466.6 575 468 573.3 468Z",
    fill: "#E83857"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M585.9 468C584.2 468 582.8 466.6 582.8 464.9V418C582.8 416.3 584.2 414.9 585.9 414.9C587.6 414.9 589 416.3 589 418V464.9C589 466.6 587.6 468 585.9 468Z",
    fill: "#E83857"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M686.597 174.182V161H682.472H678.347V174.182H665.703V178.307V182.432H678.347V217.316H682.472H686.597V182.432H699.331V178.307V174.182H686.597Z",
    fill: "#006184"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M734.753 491.365H630.281V259.374L682.472 209.783L734.753 259.374V491.365Z",
    fill: "#006184"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M734.753 503.919H630.281V271.929L682.472 222.338L734.753 271.929V503.919Z",
    fill: "#3FCDE3"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M786.944 381.691V525.8H578V381.691L682.472 342.593L786.944 381.691Z",
    fill: "#006184"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M786.944 394.246V525.8H578V394.246L682.472 355.147L786.944 394.246Z",
    fill: "#3FCDE3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M720.494 525.8H644.45V456.481C644.45 435.497 661.488 418.458 682.472 418.458C703.456 418.458 720.494 435.497 720.494 456.481V525.8Z",
    fill: "#006184"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M715.114 456.571V520.509H649.83V456.66C649.83 438.635 664.447 424.018 682.472 424.018C688.391 424.018 693.951 425.632 698.703 428.323C699.869 429.04 701.035 429.758 702.111 430.565C704.712 432.538 707.043 434.869 708.926 437.559C709.733 438.635 710.451 439.801 711.168 441.057C712.872 444.195 714.128 447.693 714.666 451.28C715.024 452.984 715.114 454.777 715.114 456.571Z",
    fill: "#01B6D1"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M682.472 403.752C692.13 403.752 699.959 395.923 699.959 386.265C699.959 376.607 692.13 368.778 682.472 368.778C672.814 368.778 664.985 376.607 664.985 386.265C664.985 395.923 672.814 403.752 682.472 403.752Z",
    fill: "#006184"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M682.472 398.371C689.158 398.371 694.578 392.951 694.578 386.265C694.578 379.579 689.158 374.159 682.472 374.159C675.786 374.159 670.366 379.579 670.366 386.265C670.366 392.951 675.786 398.371 682.472 398.371Z",
    fill: "#01B6D1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M701.483 328.155H663.461V274.35C663.461 263.858 671.98 255.339 682.472 255.339C692.964 255.339 701.483 263.858 701.483 274.35V328.155Z",
    fill: "#006184"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M668.841 322.775V274.35C668.841 266.817 674.939 260.719 682.472 260.719C690.005 260.719 696.103 266.817 696.103 274.35V322.775H668.841Z",
    fill: "#01B6D1"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M693.771 260.719L682.472 275.605V322.775",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M671.173 260.719L682.472 275.605V322.775",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M684.535 420.969H680.499V520.688H684.535V420.969Z",
    fill: "#006184"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M544.987 345.621H261.776V524.666H544.987V345.621Z",
    fill: "#3FCDE3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M547 293.503H259V353.393H547V293.503Z",
    fill: "#006184"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M268.1 350.3C266.4 350.3 265 348.895 265 347.188V300.112C265 298.405 266.4 297 268.1 297C269.8 297 271.2 298.405 271.2 300.112V347.188C271.3 348.895 269.9 350.3 268.1 350.3Z",
    fill: "#01B6D1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M285.305 350.3C283.605 350.3 282.205 348.895 282.205 347.188V300.112C282.205 298.405 283.605 297 285.305 297C287.005 297 288.405 298.405 288.405 300.112V347.188C288.405 348.895 287.005 350.3 285.305 350.3Z",
    fill: "#01B6D1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M302.505 350.3C300.805 350.3 299.405 348.895 299.405 347.188V300.112C299.405 298.405 300.805 297 302.505 297C304.205 297 305.605 298.405 305.605 300.112V347.188C305.605 348.895 304.205 350.3 302.505 350.3Z",
    fill: "#01B6D1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M319.705 350.3C318.005 350.3 316.605 348.895 316.605 347.188V300.112C316.605 298.405 318.005 297 319.705 297C321.405 297 322.805 298.405 322.805 300.112V347.188C322.805 348.895 321.405 350.3 319.705 350.3Z",
    fill: "#01B6D1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M336.905 350.3C335.205 350.3 333.805 348.895 333.805 347.188V300.112C333.805 298.405 335.205 297 336.905 297C338.605 297 340.005 298.405 340.005 300.112V347.188C340.105 348.895 338.705 350.3 336.905 350.3Z",
    fill: "#01B6D1"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M354.11 350.3C352.41 350.3 351.01 348.895 351.01 347.188V300.112C351.01 298.405 352.41 297 354.11 297C355.81 297 357.21 298.405 357.21 300.112V347.188C357.21 348.895 355.81 350.3 354.11 350.3Z",
    fill: "#01B6D1"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M371.31 350.3C369.61 350.3 368.21 348.895 368.21 347.188V300.112C368.21 298.405 369.61 297 371.31 297C373.01 297 374.41 298.405 374.41 300.112V347.188C374.41 348.895 373.01 350.3 371.31 350.3Z",
    fill: "#01B6D1"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M388.1 350.3C386.4 350.3 385 348.895 385 347.188V300.112C385 298.405 386.4 297 388.1 297C389.8 297 391.2 298.405 391.2 300.112V347.188C391.3 348.895 389.9 350.3 388.1 350.3Z",
    fill: "#01B6D1"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M405.305 350.3C403.605 350.3 402.205 348.895 402.205 347.188V300.112C402.205 298.405 403.605 297 405.305 297C407.005 297 408.405 298.405 408.405 300.112V347.188C408.405 348.895 407.005 350.3 405.305 350.3Z",
    fill: "#01B6D1"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M422.505 350.3C420.805 350.3 419.405 348.895 419.405 347.188V300.112C419.405 298.405 420.805 297 422.505 297C424.205 297 425.605 298.405 425.605 300.112V347.188C425.605 348.895 424.205 350.3 422.505 350.3Z",
    fill: "#01B6D1"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M439.705 350.3C438.005 350.3 436.605 348.895 436.605 347.188V300.112C436.605 298.405 438.005 297 439.705 297C441.405 297 442.805 298.405 442.805 300.112V347.188C442.805 348.895 441.405 350.3 439.705 350.3Z",
    fill: "#01B6D1"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M491.1 350.3C489.4 350.3 488 348.895 488 347.188V300.112C488 298.405 489.4 297 491.1 297C492.8 297 494.2 298.405 494.2 300.112V347.188C494.2 348.895 492.8 350.3 491.1 350.3Z",
    fill: "#01B6D1"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M456.905 350.3C455.205 350.3 453.805 348.895 453.805 347.188V300.112C453.805 298.405 455.205 297 456.905 297C458.605 297 460.005 298.405 460.005 300.112V347.188C460.105 348.895 458.705 350.3 456.905 350.3Z",
    fill: "#01B6D1"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M508.3 350.3C506.6 350.3 505.2 348.895 505.2 347.188V300.112C505.2 298.405 506.6 297 508.3 297C510 297 511.4 298.405 511.4 300.112V347.188C511.5 348.895 510.1 350.3 508.3 350.3Z",
    fill: "#01B6D1"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M474.11 350.3C472.41 350.3 471.01 348.895 471.01 347.188V300.112C471.01 298.405 472.41 297 474.11 297C475.81 297 477.21 298.405 477.21 300.112V347.188C477.21 348.895 475.81 350.3 474.11 350.3Z",
    fill: "#01B6D1"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M525.505 350.3C523.805 350.3 522.405 348.895 522.405 347.188V300.112C522.405 298.405 523.805 297 525.505 297C527.205 297 528.605 298.405 528.605 300.112V347.188C528.605 348.895 527.205 350.3 525.505 350.3Z",
    fill: "#01B6D1"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M491.31 350.3C489.61 350.3 488.21 348.895 488.21 347.188V300.112C488.21 298.405 489.61 297 491.31 297C493.01 297 494.41 298.405 494.41 300.112V347.188C494.41 348.895 493.01 350.3 491.31 350.3Z",
    fill: "#01B6D1"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M542.705 350.3C541.005 350.3 539.605 348.895 539.605 347.188V300.112C539.605 298.405 541.005 297 542.705 297C544.405 297 545.805 298.405 545.805 300.112V347.188C545.805 348.895 544.405 350.3 542.705 350.3Z",
    fill: "#01B6D1"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M332.022 460.155H294V406.35C294 395.858 302.519 387.339 313.011 387.339C323.503 387.339 332.022 395.858 332.022 406.35V460.155Z",
    fill: "#006184"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M299.381 454.775V406.35C299.381 398.817 305.479 392.719 313.011 392.719C320.544 392.719 326.642 398.817 326.642 406.35V454.775H299.381Z",
    fill: "#01B6D1"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M324.31 392.719L313.011 407.605V454.775",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M301.712 392.719L313.011 407.605V454.775",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M517.022 460.155H479V406.35C479 395.858 487.519 387.339 498.011 387.339C508.503 387.339 517.022 395.858 517.022 406.35V460.155Z",
    fill: "#006184"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M484.381 454.775V406.35C484.381 398.817 490.479 392.719 498.011 392.719C505.544 392.719 511.642 398.817 511.642 406.35V454.775H484.381Z",
    fill: "#01B6D1"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M509.31 392.719L498.011 407.605V454.775",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M486.712 392.719L498.011 407.605V454.775",
    stroke: "#006184",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M404.527 257L338.807 343.192H470.316L404.527 257Z",
    fill: "#006184"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M404.527 269.006L338.807 355.198H470.316L404.527 269.006Z",
    fill: "#3FCDE3"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M404.472 350.752C414.13 350.752 421.959 342.923 421.959 333.265C421.959 323.607 414.13 315.778 404.472 315.778C394.814 315.778 386.985 323.607 386.985 333.265C386.985 342.923 394.814 350.752 404.472 350.752Z",
    fill: "#006184"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M404.472 345.371C411.158 345.371 416.578 339.951 416.578 333.265C416.578 326.579 411.158 321.159 404.472 321.159C397.786 321.159 392.366 326.579 392.366 333.265C392.366 339.951 397.786 345.371 404.472 345.371Z",
    fill: "#01B6D1"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M464.123 513.355H345V524.736H464.123V513.355Z",
    fill: "#A6EEFA"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M451.806 502.043H357.231V513.424H451.806V502.043Z",
    fill: "#7DE3F4"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M321.668 272.511H304.874V303.67H321.668V272.511Z",
    fill: "#FC4E6D"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M321.668 272.511H304.874V279.52H321.668V272.511Z",
    fill: "#E83857"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M323.472 268H303V277.23H323.472V268Z",
    fill: "#FC4E6D"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M421.113 455.408H419.933C419.308 455.408 418.753 454.853 418.753 454.228V446.455C418.753 445.831 419.308 445.276 419.933 445.276H421.113C421.737 445.276 422.292 445.831 422.292 446.455V454.228C422.223 454.922 421.737 455.408 421.113 455.408Z",
    fill: "#499DBA"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M420.905 450.203H413.548C413.132 450.203 412.785 449.856 412.785 449.439C412.785 449.023 413.132 448.676 413.548 448.676H420.905C421.321 448.676 421.668 449.023 421.668 449.439C421.668 449.856 421.321 450.203 420.905 450.203Z",
    fill: "#0077A0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 395,
    width: 77,
    height: 107,
    fill: "#006184"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 401,
    width: 65,
    height: 97,
    fill: "#01B6D1"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M407.035 399H403V498.719H407.035V399Z",
    fill: "#006184"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M307.134 504.067C307.134 487.458 293.676 474 277.067 474C260.458 474 247 487.458 247 504.067C247 512.536 250.479 520.151 256.06 525.6H297.944C303.589 520.151 307.134 512.536 307.134 504.067Z",
    fill: "#2F7D80"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M514 510.788C514 499.394 523.267 490.128 534.661 490.128C546.054 490.128 555.321 499.394 555.321 510.788C555.321 516.561 552.89 521.878 549.093 525.6H520.228C516.355 521.802 514 516.561 514 510.788Z",
    fill: "#2F7D80"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M540.206 500.686C540.206 481.468 555.777 465.897 574.994 465.897C594.212 465.897 609.783 481.468 609.783 500.686C609.783 510.484 605.757 519.295 599.301 525.6H550.84C544.307 519.295 540.206 510.484 540.206 500.686Z",
    fill: "#2F7D80"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M879.4 562.2H320.6C310.3 562.2 301.9 553.8 301.9 543.5C301.9 533.2 310.3 524.8 320.6 524.8H879.3C889.6 524.8 898 533.2 898 543.5C898.1 553.9 889.7 562.2 879.4 562.2Z",
    fill: "#006184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide1);
export default __webpack_public_path__ + "static/media/slide1.adae3a67f46fa581920a745ac8451d28.svg";
export { ForwardRef as ReactComponent };